import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MenuTriggerForDirective } from './menu-trigger.directive';

@NgModule({
    declarations: [MenuTriggerForDirective],
    imports: [CommonModule],
    exports: [MenuTriggerForDirective],
})
export class MenuTriggerModule {}
